import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import loc from '../../utils/loc';

import Button from '../Button';

const LandingPage = ({ title, preTitle, description, description2, image, image2, setStarted, finalLink, skipQuizText }) => {

  return (
    <Wrapper image={image}>
      {image2 ? <Image src={image2} alt="" /> : null}
      {preTitle ? <PreTitle>{preTitle}</PreTitle> : null }
      <Title className='h2'>{title}</Title>
      <Description>{description}</Description>
      {setStarted ? <Button primary onClick={() => setStarted(true)}>{loc.t('take the test')}</Button> : null }
      {finalLink && skipQuizText ? <p><a className="primary" href={finalLink}>{skipQuizText}</a></p> : null }
      {description2 ? <Description2>{description2}</Description2> : null }
    </Wrapper>
  );
};

LandingPage.propTypes = {
  title: PropTypes.string,
  preTitle: PropTypes.string,
  image: PropTypes.string,
  image2: PropTypes.string,
  description: PropTypes.string,
  description2: PropTypes.string,
  setStarted: PropTypes.func,
  showName: PropTypes.bool,
  finalLink: PropTypes.string,
  skipQuizText: PropTypes.string
};

const Wrapper = styled.div`
  text-align: center;
`;

const Title = styled.h1`
`;

const PreTitle = styled.h2`
  font-size: 1rem;
  letter-spacing: 1px;
`;

const Description = styled.p`
  font-weight: bold;
  letter-spacing: 1px;
`;

const Description2 = styled.p`
`;

const Image = styled.img`
  margin-bottom: 40px;
`;

export default LandingPage;
